import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";
import SEO from "../../components/site/SEO";
import { Logo } from "../../components/site/Header";
import { inputCls, labelCls, btnPrimaire } from "./ui";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [erreur, setErreur] = useState("");
  const [envoi, setEnvoi] = useState(false);

  if (user) {
    navigate("/admin/tableau-de-bord", { replace: true });
    return null;
  }

  const soumettre = async (e) => {
    e.preventDefault();
    setErreur("");
    setEnvoi(true);
    try {
      await login(email, password);
      navigate("/admin/tableau-de-bord", { replace: true });
    } catch (err) {
      setErreur(formatApiError(err.response?.data?.detail));
    } finally {
      setEnvoi(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-dark flex items-center justify-center px-4 py-12">
      <SEO title="Connexion — Espace gérant | Promo Pneus" description="Espace réservé au gérant du garage Promo Pneus." />
      <div className="w-full max-w-md bg-white p-8 sm:p-10" data-testid="admin-login">
        <div className="mb-8 text-center">
          <Logo />
          <p className="mt-3 text-brand-body font-body">Espace réservé au gérant</p>
        </div>
        <form onSubmit={soumettre} className="space-y-5">
          <div>
            <label htmlFor="admin-email" className={labelCls}>Adresse email</label>
            <input id="admin-email" data-testid="admin-email" type="email" required
              value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="votre@email.fr" autoComplete="username" className={inputCls} />
          </div>
          <div>
            <label htmlFor="admin-motdepasse" className={labelCls}>Mot de passe</label>
            <input id="admin-motdepasse" data-testid="admin-motdepasse" type="password" required
              value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="Votre mot de passe" autoComplete="current-password" className={inputCls} />
          </div>
          {erreur && (
            <p data-testid="admin-login-erreur" role="alert"
              className="text-brand-redhover font-medium bg-red-50 border-l-4 border-brand-red px-4 py-3">
              {erreur}
            </p>
          )}
          <button type="submit" data-testid="admin-connexion" disabled={envoi} className={`${btnPrimaire} w-full`}>
            {envoi ? "Connexion en cours…" : "Se connecter"}
          </button>
        </form>
        <p className="mt-6 text-center">
          <a href="/" className="text-brand-body underline hover:text-brand-red transition-colors">
            Retour au site
          </a>
        </p>
      </div>
    </div>
  );
}
